<kt-portlet>

	<kt-portlet-body>
		<div class="machine-list-actions" *ngIf="role === 'sadmin'">
			<button mat-icon-button [matMenuTriggerFor]="contextMenu" aria-label="More options">
				<mat-icon>more_vert</mat-icon>
			</button>
			<mat-menu #contextMenu="matMenu" class="machine-list-context-menu">
				<button mat-menu-item (click)="navigateToRegisterMachine()">
					Register Machine
				</button>
			</mat-menu>
		</div>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div class="kt-form kt-margin-b-30">
			<!-- start::FILTERS -->
			<div class="kt-form__filtration">
				<div class="filters-container">
					<div class="hierarchical-filters-row">
						<kt-hierarchical-filters
							[role]="role"
							[showDistributor]="role == 'sadmin'"
							[showMarket]="role == 'sadmin' || role == 'distiadmin'"
							[showClient]="role == 'sadmin' || role == 'distiadmin' || role == 'marketadmin'"
							[showCampus]="role == 'sadmin' || role == 'distiadmin' || role == 'marketadmin' || role == 'clientadmin'"
							[multiple]="false"
							[initialValues]="hierarchicalFilterInitialValues"
							(filterChange)="onFiltersChange($event)">
						</kt-hierarchical-filters>
					</div>

					<div class="hierarchical-filters hierarchical-filters-row">
						<div class="scope-select-wrapper">
							<label class="scope-select-label">Filter by Connectivity</label>
							<kt-searchable-select
								[options]="connectivityOptions"
								placeholder="All"
								[searchPlaceholder]="'Search...'"
								[(ngModel)]="filterConnValue"
								[multiple]="false"
								[searchable]="false"
								(selectionChange)="onConnectivityChange($event)">
							</kt-searchable-select>
						</div>
						<div class="scope-select-wrapper">
							<label class="scope-select-label">Filter by Status</label>
							<kt-searchable-select
								[options]="statusOptions"
								placeholder="All"
								[searchPlaceholder]="'Search...'"
								[(ngModel)]="filterStatusValue"
								[multiple]="false"
								[searchable]="false"
								(selectionChange)="onStatusChange($event)">
							</kt-searchable-select>
						</div>
						<div class="scope-select-wrapper">
							<label class="scope-select-label">Filter by Machine Status</label>
							<kt-searchable-select
								[options]="machineStatusOptions"
								placeholder="All"
								[searchPlaceholder]="'Search...'"
								[(ngModel)]="filterMacStatusValue"
								[multiple]="false"
								[searchable]="false"
								(selectionChange)="onMachineStatusChange($event)">
							</kt-searchable-select>
						</div>
						<div class="scope-select-wrapper" *ngIf="role === 'sadmin'">
							<label class="scope-select-label">Filter by Service Type</label>
							<kt-searchable-select
								[options]="vendModeOptions"
								placeholder="All Machines"
								[searchPlaceholder]="'Search...'"
								[(ngModel)]="filterVendModeValue"
								[multiple]="false"
								[searchable]="false"
								(selectionChange)="onVendModeChange($event)">
							</kt-searchable-select>
						</div>
						<div class="scope-select-wrapper" *ngIf="role === 'sadmin'">
							<label class="scope-select-label">Filter by BrewVision</label>
							<kt-searchable-select
								[options]="cameraOptions"
								placeholder="All Machines"
								[searchPlaceholder]="'Search...'"
								[(ngModel)]="filterCameraValue"
								[multiple]="false"
								[searchable]="false"
								(selectionChange)="onCameraChange($event)">
							</kt-searchable-select>
						</div>
					</div>
				</div>

				<div class="row align-items-center">
					<div class="col-md-4 kt-margin-bottom-10-mobile">
							<mat-form-field>
								<input matInput placeholder="Search" #searchInput class="mat-form-field mat-form-field-fluid">
								<mat-hint align="start">
									<strong>Search by Machine Id</strong>
								</mat-hint>
							</mat-form-field>
						</div>

						<div>
							<h1></h1>
						</div>
							<div *ngIf="isFilterCached">
								<button mat-raised-button type="button" (click)="onClearFilters()" color="warn">
									Clear Filters
								</button>
							</div>

				</div>

				</div>
			<!-- end::FILTERS -->
		</div>
		<!-- end::FILTERS & GROUP ACTIONS -->

		<div class="mat-table__wrapper">

			<mat-table class="lmat-elevation-z8"
				#table
				[dataSource]="dataSource"
				matSort
				matSortActive="serial_no"
				matSortDirection="asc"
				matSortDisableClear>

				<ng-container matColumnDef="machine_id">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Machine ID</mat-header-cell>
					<mat-cell class="machine-id-cell" *matCellDef="let machine">
						<a
							class="text-primary cursor underline"
							[href]="getMachineUrl(machine, 'inventory')"
							matTooltip="View machine details"
							(click)="onMachineClick($event, machine)">
							{{machine.machine_id_display || machine.machine_id}}
						</a>
						<div class="machine-id-cell__actions" *ngIf="isSuperAdmin()">
							<button
								mat-icon-button
								class="copy-machine-id-btn"
								(click)="copyMachineId(machine.machine_id, $event)"
								matTooltip="Copy Machine ID"
								aria-label="Copy Machine ID">
								<mat-icon>content_copy</mat-icon>
							</button>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="serial_no">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Serial No</mat-header-cell>
					<!-- <mat-cell (click)="onMachine(machine)" style="text-decoration: underline;cursor: pointer;" class="text-primary cursor"  *matCellDef="let machine">{{machine.serial_no}}</mat-cell> -->
					<mat-cell *matCellDef="let machine">{{machine.serial_no}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="machine_name">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Machine Name</mat-header-cell>
					<mat-cell *matCellDef="let machine">{{machine.machine_name}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="machine_status">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
					<mat-cell *matCellDef="let machine">
						<a
							class="inline-flex align-middle ml-3 cursor-pointer"
							[href]="getMachineUrl(machine, 'open-issues')"
							(click)="onStatClick($event, machine)"
							(mouseenter)="onStatusIconMouseEnter($event, machine)"
							(mouseleave)="onStatusIconMouseLeave()">
							<mat-icon [ngClass]="getItemStatusColor(machine.machine_status)">{{getItemStatusIcon(machine.machine_status)}}</mat-icon>
						</a>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="connectivity">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Connectivity</mat-header-cell>
					<mat-cell *matCellDef="let machine">
						<!-- <mat-icon>cloud_off</mat-icon> -->
						<mat-icon
							class="ml-3"
							style="vertical-align: middle;"
							(mouseenter)="onConnectivityIconMouseEnter($event, machine)"
							(mouseleave)="onConnectivityIconMouseLeave()"
							[ngClass]="getConnectionColor(machine.connectivity)">{{getConnectionIcon(machine.connectivity)}}</mat-icon>
						<!-- <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--{{ getItemCssClassByConnection(machine.connectivity) }} kt-badge--wide">{{ getItemConnectionStatusString(machine.connectivity) }}</span> -->
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="brewvision">
					<mat-header-cell *matHeaderCellDef>BrewVision</mat-header-cell>
					<mat-cell *matCellDef="let machine">
						<mat-icon
							*ngIf="machine.brewvision"
							class="ml-3"
							style="vertical-align: middle;"
							[ngClass]="isBrewVisionWorking(machine) ? 'text-success' : 'text-danger'"
							(mouseenter)="onBrewVisionIconMouseEnter($event, machine)"
							(mouseleave)="onConnectivityIconMouseLeave()">{{ isBrewVisionWorking(machine) ? 'visibility' : 'visibility_off' }}</mat-icon>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>
			<div class="mat-table__message" *ngIf="!(dataSource.loading$ | async) && dataSource.empty">No records found</div>
			<div class="mat-table__message" *ngIf="dataSource.loading$ | async">Please wait....</div>
		</div>

		<div class="mat-table__bottom">
			<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			<mat-paginator [pageSize]="50" [pageSizeOptions]="[10, 25, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
		</div>
	</kt-portlet-body>

</kt-portlet>

<!-- Custom HTML tooltip - moved outside portlet to avoid positioning context issues -->
<div
	*ngIf="tooltipVisible"
	class="machine-list-status-tooltip"
	[style.left.px]="tooltipX"
	[style.top.px]="tooltipY"
	[innerHTML]="tooltipHtml"
	role="tooltip">
</div>
